export default __webpack_public_path__ + "static/media/img6.fec0d213.PNG";